export const CountriesList = [
  { "code": "+93", "flag": "https://flagcdn.com/w320/af.png" },
  { "code": "+355", "flag": "https://flagcdn.com/w320/al.png" },
  { "code": "+213", "flag": "https://flagcdn.com/w320/dz.png" },
  { "code": "+376", "flag": "https://flagcdn.com/w320/ad.png" },
  { "code": "+244", "flag": "https://flagcdn.com/w320/ao.png" },
  { "code": "+54", "flag": "https://flagcdn.com/w320/ar.png" },
  { "code": "+374", "flag": "https://flagcdn.com/w320/am.png" },
  { "code": "+61", "flag": "https://flagcdn.com/w320/au.png" },
  { "code": "+43", "flag": "https://flagcdn.com/w320/at.png" },
  { "code": "+994", "flag": "https://flagcdn.com/w320/az.png" },
  { "code": "+1", "flag": "https://flagcdn.com/w320/us.png" },
  { "code": "+1-268", "flag": "https://flagcdn.com/w320/ag.png" },
  { "code": "+1-242", "flag": "https://flagcdn.com/w320/bs.png" },
  { "code": "+973", "flag": "https://flagcdn.com/w320/bh.png" },
  { "code": "+880", "flag": "https://flagcdn.com/w320/bd.png" },
  { "code": "+1-246", "flag": "https://flagcdn.com/w320/bb.png" },
  { "code": "+375", "flag": "https://flagcdn.com/w320/by.png" },
  { "code": "+32", "flag": "https://flagcdn.com/w320/be.png" },
  { "code": "+501", "flag": "https://flagcdn.com/w320/bz.png" },
  { "code": "+229", "flag": "https://flagcdn.com/w320/bj.png" },
  { "code": "+1-441", "flag": "https://flagcdn.com/w320/bm.png" },
  { "code": "+975", "flag": "https://flagcdn.com/w320/bt.png" },
  { "code": "+591", "flag": "https://flagcdn.com/w320/bo.png" },
  { "code": "+387", "flag": "https://flagcdn.com/w320/ba.png" },
  { "code": "+267", "flag": "https://flagcdn.com/w320/bw.png" },
  { "code": "+55", "flag": "https://flagcdn.com/w320/br.png" },
  { "code": "+359", "flag": "https://flagcdn.com/w320/bg.png" },
  { "code": "+226", "flag": "https://flagcdn.com/w320/bf.png" },
  { "code": "+257", "flag": "https://flagcdn.com/w320/bi.png" },
  { "code": "+855", "flag": "https://flagcdn.com/w320/kh.png" },
  { "code": "+237", "flag": "https://flagcdn.com/w320/cm.png" },
  { "code": "+1-242", "flag": "https://flagcdn.com/w320/cb.png" },
  { "code": "+238", "flag": "https://flagcdn.com/w320/cv.png" },
  { "code": "+1-345", "flag": "https://flagcdn.com/w320/ky.png" },
  { "code": "+236", "flag": "https://flagcdn.com/w320/cf.png" },
  { "code": "+235", "flag": "https://flagcdn.com/w320/cm.png" },
  { "code": "+57", "flag": "https://flagcdn.com/w320/co.png" },
  { "code": "+269", "flag": "https://flagcdn.com/w320/km.png" },
  { "code": "+242", "flag": "https://flagcdn.com/w320/cg.png" },
  { "code": "+243", "flag": "https://flagcdn.com/w320/cd.png" },
  { "code": "+682", "flag": "https://flagcdn.com/w320/ck.png" },
  { "code": "+506", "flag": "https://flagcdn.com/w320/cr.png" },
  { "code": "+225", "flag": "https://flagcdn.com/w320/ci.png" },
  { "code": "+385", "flag": "https://flagcdn.com/w320/hr.png" },
  { "code": "+53", "flag": "https://flagcdn.com/w320/cu.png" },
  { "code": "+357", "flag": "https://flagcdn.com/w320/cy.png" },
  { "code": "+420", "flag": "https://flagcdn.com/w320/cz.png" },
  { "code": "+45", "flag": "https://flagcdn.com/w320/dk.png" },
  { "code": "+253", "flag": "https://flagcdn.com/w320/dj.png" },
  { "code": "+1-767", "flag": "https://flagcdn.com/w320/dm.png" },
  { "code": "+1-809", "flag": "https://flagcdn.com/w320/do.png" },
  { "code": "+593", "flag": "https://flagcdn.com/w320/ec.png" },
  { "code": "+20", "flag": "https://flagcdn.com/w320/eg.png" },
  { "code": "+503", "flag": "https://flagcdn.com/w320/sv.png" },
  { "code": "+240", "flag": "https://flagcdn.com/w320/gq.png" },
  { "code": "+291", "flag": "https://flagcdn.com/w320/er.png" },
  { "code": "+372", "flag": "https://flagcdn.com/w320/ee.png" },
  { "code": "+251", "flag": "https://flagcdn.com/w320/et.png" },
  { "code": "+500", "flag": "https://flagcdn.com/w320/fk.png" },
  { "code": "+298", "flag": "https://flagcdn.com/w320/fo.png" },
  { "code": "+679", "flag": "https://flagcdn.com/w320/fj.png" },
  { "code": "+358", "flag": "https://flagcdn.com/w320/fi.png" },
  { "code": "+33", "flag": "https://flagcdn.com/w320/fr.png" },
  { "code": "+594", "flag": "https://flagcdn.com/w320/gf.png" },
  { "code": "+689", "flag": "https://flagcdn.com/w320/pf.png" },
  { "code": "+241", "flag": "https://flagcdn.com/w320/ga.png" },
  { "code": "+220", "flag": "https://flagcdn.com/w320/gm.png" },
  { "code": "+995", "flag": "https://flagcdn.com/w320/ge.png" },
  { "code": "+233", "flag": "https://flagcdn.com/w320/gh.png" },
  { "code": "+350", "flag": "https://flagcdn.com/w320/gi.png" },
  { "code": "+30", "flag": "https://flagcdn.com/w320/gr.png" },
  { "code": "+299", "flag": "https://flagcdn.com/w320/gl.png" },
  { "code": "+502", "flag": "https://flagcdn.com/w320/gt.png" },
  { "code": "+44-1481", "flag": "https://flagcdn.com/w320/gg.png" },
  { "code": "+224", "flag": "https://flagcdn.com/w320/gn.png" },
  { "code": "+245", "flag": "https://flagcdn.com/w320/gw.png" },
  { "code": "+592", "flag": "https://flagcdn.com/w320/gy.png" },
  { "code": "+509", "flag": "https://flagcdn.com/w320/ht.png" },
  { "code": "+504", "flag": "https://flagcdn.com/w320/hn.png" },
  { "code": "+852", "flag": "https://flagcdn.com/w320/hk.png" },
  { "code": "+36", "flag": "https://flagcdn.com/w320/hu.png" },
  { "code": "+354", "flag": "https://flagcdn.com/w320/is.png" },
  { "code": "+91", "flag": "https://flagcdn.com/w320/in.png" },
  { "code": "+62", "flag": "https://flagcdn.com/w320/id.png" },
  { "code": "+98", "flag": "https://flagcdn.com/w320/ir.png" },
  { "code": "+964", "flag": "https://flagcdn.com/w320/iq.png" },
  { "code": "+353", "flag": "https://flagcdn.com/w320/ie.png" },
  { "code": "+972", "flag": "https://flagcdn.com/w320/il.png" },
  { "code": "+1-876", "flag": "https://flagcdn.com/w320/jm.png" },
  { "code": "+81", "flag": "https://flagcdn.com/w320/jp.png" },
  { "code": "+962", "flag": "https://flagcdn.com/w320/jo.png" },
  { "code": "+7", "flag": "https://flagcdn.com/w320/ru.png" },
  { "code": "+254", "flag": "https://flagcdn.com/w320/ke.png" },
  { "code": "+686", "flag": "https://flagcdn.com/w320/ki.png" },
  { "code": "+965", "flag": "https://flagcdn.com/w320/kw.png" },
  { "code": "+996", "flag": "https://flagcdn.com/w320/kg.png" },
  { "code": "+856", "flag": "https://flagcdn.com/w320/la.png" },
  { "code": "+371", "flag": "https://flagcdn.com/w320/lv.png" },
  { "code": "+961", "flag": "https://flagcdn.com/w320/lb.png" },
  { "code": "+266", "flag": "https://flagcdn.com/w320/ls.png" },
  { "code": "+231", "flag": "https://flagcdn.com/w320/lr.png" },
  { "code": "+218", "flag": "https://flagcdn.com/w320/ly.png" },
  { "code": "+423", "flag": "https://flagcdn.com/w320/li.png" },
  { "code": "+370", "flag": "https://flagcdn.com/w320/lt.png" },
  { "code": "+352", "flag": "https://flagcdn.com/w320/lu.png" },
  { "code": "+261", "flag": "https://flagcdn.com/w320/mg.png" },
  { "code": "+265", "flag": "https://flagcdn.com/w320/mw.png" },
  { "code": "+60", "flag": "https://flagcdn.com/w320/my.png" },
  { "code": "+960", "flag": "https://flagcdn.com/w320/mv.png" },
  { "code": "+223", "flag": "https://flagcdn.com/w320/ml.png" },
  { "code": "+230", "flag": "https://flagcdn.com/w320/mu.png" },
  { "code": "+262", "flag": "https://flagcdn.com/w320/re.png" },
  { "code": "+52", "flag": "https://flagcdn.com/w320/mx.png" },
  { "code": "+691", "flag": "https://flagcdn.com/w320/fm.png" },
  { "code": "+373", "flag": "https://flagcdn.com/w320/md.png" },
  { "code": "+377", "flag": "https://flagcdn.com/w320/mc.png" },
  { "code": "+976", "flag": "https://flagcdn.com/w320/mn.png" },
  { "code": "+382", "flag": "https://flagcdn.com/w320/me.png" },
  { "code": "+1-664", "flag": "https://flagcdn.com/w320/ms.png" },
  { "code": "+212", "flag": "https://flagcdn.com/w320/ma.png" },
  { "code": "+258", "flag": "https://flagcdn.com/w320/mz.png" },
  { "code": "+95", "flag": "https://flagcdn.com/w320/mm.png" },
  { "code": "+264", "flag": "https://flagcdn.com/w320/na.png" },
  { "code": "+674", "flag": "https://flagcdn.com/w320/nu.png" },
  { "code": "+977", "flag": "https://flagcdn.com/w320/np.png" },
  { "code": "+31", "flag": "https://flagcdn.com/w320/nl.png" },
  { "code": "+687", "flag": "https://flagcdn.com/w320/nc.png" },
  { "code": "+64", "flag": "https://flagcdn.com/w320/nz.png" },
  { "code": "+505", "flag": "https://flagcdn.com/w320/ni.png" },
  { "code": "+227", "flag": "https://flagcdn.com/w320/ne.png" },
  { "code": "+234", "flag": "https://flagcdn.com/w320/ng.png" },
  { "code": "+683", "flag": "https://flagcdn.com/w320/nu.png" },
  { "code": "+47", "flag": "https://flagcdn.com/w320/no.png" },
  { "code": "+968", "flag": "https://flagcdn.com/w320/om.png" },
  { "code": "+92", "flag": "https://flagcdn.com/w320/pk.png" },
  { "code": "+680", "flag": "https://flagcdn.com/w320/pw.png" },
  { "code": "+970", "flag": "https://flagcdn.com/w320/ps.png" },
  { "code": "+595", "flag": "https://flagcdn.com/w320/py.png" },
  { "code": "+51", "flag": "https://flagcdn.com/w320/pe.png" },
  { "code": "+63", "flag": "https://flagcdn.com/w320/ph.png" },
  { "code": "+48", "flag": "https://flagcdn.com/w320/pl.png" },
  { "code": "+351", "flag": "https://flagcdn.com/w320/pt.png" },
  { "code": "+1787", "flag": "https://flagcdn.com/w320/pr.png" },
  { "code": "+1-649", "flag": "https://flagcdn.com/w320/tc.png" },
  { "code": "+590", "flag": "https://flagcdn.com/w320/gp.png" },
  { "code": "+508", "flag": "https://flagcdn.com/w320/pf.png" },
  { "code": "+689", "flag": "https://flagcdn.com/w320/pf.png" },
  { "code": "+1-767", "flag": "https://flagcdn.com/w320/dm.png" },
  { "code": "+1-284", "flag": "https://flagcdn.com/w320/vg.png" },
  { "code": "+1-345", "flag": "https://flagcdn.com/w320/ky.png" },
  { "code": "+1-758", "flag": "https://flagcdn.com/w320/lc.png" },
  { "code": "+1-721", "flag": "https://flagcdn.com/w320/sx.png" },
  { "code": "+590", "flag": "https://flagcdn.com/w320/gp.png" },
  { "code": "+1-868", "flag": "https://flagcdn.com/w320/tt.png" },
  { "code": "+1-877", "flag": "https://flagcdn.com/w320/ca.png" },
  { "code": "+962", "flag": "https://flagcdn.com/w320/jo.png" },
  { "code": "+260", "flag": "https://flagcdn.com/w320/zm.png" },
  { "code": "+263", "flag": "https://flagcdn.com/w320/zw.png" },
  { "code": "+350", "flag": "https://flagcdn.com/w320/gi.png" },
  { "code": "+378", "flag": "https://flagcdn.com/w320/sm.png" },
  { "code": "+39", "flag": "https://flagcdn.com/w320/it.png" },
  { "code": "+387", "flag": "https://flagcdn.com/w320/ba.png" },
  { "code": "+239", "flag": "https://flagcdn.com/w320/st.png" },
  { "code": "+244", "flag": "https://flagcdn.com/w320/ao.png" },
  { "code": "+963", "flag": "https://flagcdn.com/w320/sy.png" },
  { "code": "+886", "flag": "https://flagcdn.com/w320/tw.png" },
  { "code": "+855", "flag": "https://flagcdn.com/w320/kh.png" },
  { "code": "+882", "flag": "https://flagcdn.com/w320/oa.png" },
  { "code": "+855", "flag": "https://flagcdn.com/w320/kh.png" },
  { "code": "+968", "flag": "https://flagcdn.com/w320/om.png" },
  { "code": "+678", "flag": "https://flagcdn.com/w320/vu.png" },
  { "code": "+679", "flag": "https://flagcdn.com/w320/fj.png" },
  { "code": "+881", "flag": "https://flagcdn.com/w320/ja.png" },
  { "code": "+960", "flag": "https://flagcdn.com/w320/mv.png" },
  { "code": "+963", "flag": "https://flagcdn.com/w320/sy.png" },
  { "code": "+963", "flag": "https://flagcdn.com/w320/sy.png" },
  { "code": "+998", "flag": "https://flagcdn.com/w320/uz.png" }
];
